import React, { useReducer } from 'react'
import PropTypes from 'prop-types'

import { ThemeContext } from './Theme.context'
import { ThemeReducer } from './Theme.reducer'
import { UPDATE_THEME, ThemeState, ThemeOptions } from './Theme.types'

interface Props {
  children?: React.ReactNode
}

export const ThemeProvider: React.FC<Props> = ({ children }) => {
  let initialState: ThemeState = {
    theme: 'light',
    updateTheme: () => null,
  }

  const [state, dispatch] = useReducer(ThemeReducer, initialState)

  const updateTheme = (theme: ThemeOptions) => {
    dispatch({ type: UPDATE_THEME, payload: theme })
  }
  initialState = {
    ...initialState,
    updateTheme,
  }
  return (
    <ThemeContext.Provider
      value={{
        theme: state.theme,
        updateTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

ThemeProvider.propTypes = {
  children: PropTypes.element.isRequired,
}
